import React from 'react';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';

export const CheckboxElement = ({ item, value, onChange, readOnly }) => {
    const handleChange = (option) => {
        if (readOnly) return;
        const selected = Array.isArray(value) ? value : [];
        const isSelected = selected.some((s) => s.id === option.id);

        let newValue;
        if (isSelected) {
            newValue = selected.filter((s) => s.id !== option.id);
        } else {
            newValue = [...selected, { name: option.name, id: option.id }];
        }
        onChange(newValue);
    };

    const options = (item?.properties?.options || []).filter((opt) => opt.name && opt.name.trim() !== '');
    const selectedValues = Array.isArray(value) ? value : [];

    return (
        <FormGroup style={{ width: 'fit-content' }}>
            {options.map((opt) => (
                <FormControlLabel
                    key={opt.id}
                    control={
                        <Checkbox
                            checked={selectedValues.some((s) => s.id === opt.id)}
                            onChange={() => handleChange(opt)}
                            color="primary"
                            disabled={readOnly}
                            style={{ padding: '4px 8px' }}
                        />
                    }
                    label={opt.name}
                />
            ))}
        </FormGroup>
    );
};
